/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import { has } from 'lodash';
import withJobActions from './withJobActions';
import TextInput from '../../../common/controls/textInput';
const JobFlangeValveInformationSubsection = props => {
  const active = props.active,
    onJobChange = props.onJobChange,
    userID = props.userID;
  const _active$flangeValve = active.flangeValve,
    flangeValve = _active$flangeValve === void 0 ? [] : _active$flangeValve,
    id = active.id;
  const fv = useMemo(() => {
    if (Array.isArray(flangeValve) && flangeValve.length > 0) {
      return flangeValve[0];
    }
    return {};
  }, [flangeValve]);
  const handleChange = useCallback((name, value) => {
    if (!has(fv, 'jobID')) {
      // its new...
      const newFV = {
        [name]: value,
        jobID: id,
        appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        appCreatorID: userID,
        id: uuidV4().toUpperCase()
      };
      // need to add the whole value
      onJobChange('flangeValve[0]', newFV);
    } else {
      onJobChange("flangeValve[0]/".concat(name), value);
    }
  }, [fv, id, onJobChange, userID]);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Flange / Valve Information"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Piping Circuit",
    field: "pipingCircuit",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Line #",
    field: "lineNumber",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Line Spec",
    field: "lineSpec",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Sheet #",
    field: "sheetNumber",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Size",
    field: "size",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Class",
    field: "classification",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Equipment #",
    field: "equipmentNumber",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Nozzle #",
    field: "nozzleNumber",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Service Classification",
    field: "serviceClassification",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Flange Valve #",
    field: "flangeValveNumber",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Operating in 150# Class",
    field: "operatingClass",
    data: fv,
    onChange: handleChange,
    entity: "Job"
  }))));
};
JobFlangeValveInformationSubsection.propTypes = {
  userID: PropTypes.string.isRequired,
  active: PropTypes.shape({
    id: PropTypes.string.isRequired,
    flangeValve: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onJobChange: PropTypes.func.isRequired
};
export { JobFlangeValveInformationSubsection as UncomposedJobFlangeValveInformationSubsection };
export default withJobActions(JobFlangeValveInformationSubsection);